import { getWorkspaceLoginRequirements } from '#services';
export const canFetchWorkspaceData = (workspaceLoginStatus) => {
    if (!workspaceLoginStatus) {
        return false;
    }
    const { isFullLoginRequired, isLoggedIn, isMfaRequired, isSsoLoginRequired, } = getWorkspaceLoginRequirements(workspaceLoginStatus);
    return (isLoggedIn ||
        // the check below is a passthrough which would allow the user to perform a request
        // in order to get the correct WorkspaceLoginStatus
        // example: user has not yet logged in the Workspace
        // and in order to be even able to make these check below are necessary
        (!isSsoLoginRequired && !isFullLoginRequired && !isMfaRequired));
};
